import styled from 'styled-components'
import { lineClamp } from 'components/Common/GlobalStyles'
import FlagIcon from 'components/Common/FlagIcon'
import {
  getWineGrapeVarietiesStrings,
  getWineGeoIndicationString,
  getWineNationalGITypeString,
  joinValues,
} from 'utils/wine'
import { LineWithSeparator } from 'components/Common/Table/_styles'

const Wrapper = styled.div`
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  width: 384px;
  box-sizing: border-box;
`

const Img = styled.img`
  display: flex;
  align-items: flex-start;
  margin-right: 8px;
  min-width: 96px;
  height: 96px;
  object-fit: contain;
  object-position: top center;
`

const Content = styled.div`
  min-width: 248px;
  font-family: var(--typography-normal);
  word-break: break-word;
`

const Block = styled.div<{ gap: number }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${props => props.gap ?? 4}px;
  width: 100%;
`

const TradeName = styled.span`
  width: 100%;
  ${LineWithSeparator} {
    font: var(--typography-12-16-semibold);
    color: var(--color-night);
    /* ${lineClamp()}; */
  }
`

const CountryIcon = styled(FlagIcon)`
  display: inline-block;
  margin-right: 4px;
  margin-bottom: -1px;
`

const Parameters = styled.div`
  font: var(--typography-11-16-normal);
  color: #717284;
  ${lineClamp(3)};
`

const Grapes = styled.div`
  font: var(--typography-11-16-normal);
  color: #717284;
  ${lineClamp(3)};
`
const ProductName = styled.div`
  font: var(--typography-12-16-semibold);
  color: var(--color-night);
  display: inline; /* Текст ведёт себя как инлайновый, переносится по словам/символам */
  word-wrap: break-word;
`
const ProductDetails = styled.div``

const ProductPopoverContent = ({ product, imageUrl }) => {
  const wine = product?.wine
  const tradeNameBrand = wine?.tradeNameBrand ?? ''
  const wineGI = joinValues(
    [getWineGeoIndicationString(wine, ' '), getWineNationalGITypeString(wine)],
    ' '
  )
  const country = wine?.country
  const grapeVarieties = getWineGrapeVarietiesStrings(wine).join(' • ')
  const tradeName = (
    <ProductDetails>
      {country?.codeISO && <CountryIcon size={18} codeISO={country?.codeISO} />}
      <ProductName>
        {[tradeNameBrand, wine?.vintageText].filter(Boolean).join(' ')}
      </ProductName>
    </ProductDetails>
  )
  const parameters = (
    <ProductDetails>
      {[country?.localizedName, wineGI].filter(Boolean).join(', ')}
    </ProductDetails>
  )

  return (
    <Wrapper>
      {imageUrl && <Img src={imageUrl} alt='bottle image' />}

      <Content>
        <Block gap={4}>
          <TradeName>{tradeName}</TradeName>
          {parameters && <Parameters>{parameters}</Parameters>}
          {grapeVarieties && <Grapes>{grapeVarieties}</Grapes>}
        </Block>
      </Content>
    </Wrapper>
  )
}

export default ProductPopoverContent
